import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import { pl } from 'date-fns/locale';
import { bagStatuses } from '@/constants/Bag';

export const SealField = record => {
    if (!record) return null;

    if (record.status === bagStatuses.collected || record.status === bagStatuses.error || record.status === bagStatuses.manually_closed) {
        return (
            <Box sx={{ width: 'max-content', gap: '4px' }}>
                <Typography variant='body2' sx={{ fontWeight: 600 }}>
                    {record.seal || '—'}
                </Typography>
                <Typography variant='body2' sx={{ fontSize: '11px !important' }}>
                    {record.sealScanningTime ? format(new Date(record.sealScanningTime), 'dd.MM.yyyy, HH:mm', { locale: pl }) : '—'}
                </Typography>
            </Box>
        );
    }

    if (record.status === bagStatuses.in_progress) {
        return (
            <Typography variant='body2' className='gray'>
                —
            </Typography>
        );
    }

    return record.seal || '—';
};
